module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido.a6b7496f.svg";